module.exports = __webpack_public_path__ + "img/orbis-device.730ca068.png";